import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Alluz Logo Component
const AlluzLogo = ({ className = "", size = 60 }) => (
  <img 
    src="/logo-alluz.png" 
    alt="Alluz Energia" 
    className={className}
    style={{ width: size, height: size, objectFit: 'contain' }}
  />
);

export default function VideoSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="video"
      ref={ref}
      className="py-20 sm:py-24 px-4 sm:px-6 bg-gradient-to-b from-[#FFF7ED] to-[#FFFBEB] relative overflow-hidden"
      data-testid="video-section"
    >
      {/* Background Decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full bg-gradient-to-br from-[#FFB414]/10 to-transparent blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] rounded-full bg-gradient-to-tl from-[#FFC940]/10 to-transparent blur-3xl" />
      </div>

      <div className="container mx-auto max-w-5xl relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <motion.div 
            className="inline-flex items-center gap-3 mb-5"
            whileHover={{ scale: 1.05 }}
          >
            <AlluzLogo size={50} />
          </motion.div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black font-['Outfit'] text-[#92400E] mb-4">
            Conheça a <span className="gradient-text">Alluz</span>
          </h2>
          <p className="text-base sm:text-lg text-[#92400E]/60 max-w-2xl mx-auto px-4">
            Descubra como transformamos a energia do sol em economia para milhares de famílias.
          </p>
        </motion.div>

        {/* Institutional Video */}
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={isInView ? { opacity: 1, y: 0, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative"
        >
          <div className="relative aspect-video rounded-3xl overflow-hidden shadow-2xl shadow-[#FFB414]/30 border-4 border-white/80 bg-black">
            <iframe
              className="h-full w-full"
              src="https://www.youtube.com/embed/yLSVl9S6loI"
              title="Vídeo institucional Alluz"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-12 flex flex-wrap justify-center gap-6 sm:gap-10"
        >
          {[
            { value: "300+", label: "Projetos" },
            { value: "95%", label: "Satisfação" },
            { value: "25+", label: "Anos de Garantia" },
          ].map((item, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl sm:text-3xl font-black font-['Outfit'] gradient-text">
                {item.value}
              </div>
              <div className="text-sm text-[#92400E]/60 font-medium">
                {item.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
